import { useEffect } from 'react';

export const useLockScrollWithOverscroll = (isLocked: boolean): void => {
  useEffect(() => {
    if (!isLocked) {
      return;
    }

    const scrollY = window.scrollY;
    const body = document.body;

    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    body.dataset.scrollLock = 'true';

    document.documentElement.style.overscrollBehavior = 'none';
    body.style.overscrollBehavior = 'none';
    (body.style as any).webkitOverflowScrolling = 'auto';

    return () => {
      const prevScrollY = -parseInt(body.style.top || '0', 10);
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      body.style.overflow = '';
      delete body.dataset.scrollLock;

      document.documentElement.style.overscrollBehavior = '';
      body.style.overscrollBehavior = '';
      (body as any).style.webkitOverflowScrolling = '';
      window.scrollTo(0, prevScrollY);
    };
  }, [isLocked]);
};
